import { render, staticRenderFns } from "./AgeLabel.vue?vue&type=template&id=b101e0c6&"
import script from "./AgeLabel.vue?vue&type=script&lang=ts&"
export * from "./AgeLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports